exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-nps{display:block;margin-top:20px;color:#3598dc!important;font-weight:700;text-transform:uppercase}.media-nps span{font-size:22px}.default-bg{color:#fff;padding:4px 10px;border-radius:4px!important;width:100px}.default-bg,.total-dnp{text-align:center;display:block}.total-dnp{font-weight:400;font-size:18px}.total-dnp span{display:block;font-size:26px;margin-top:5px;font-weight:500}.btn-all-excel{cursor:pointer;display:inline-block;padding:8px 10px;background-color:#00a651;color:#fff;margin-bottom:20px;border-radius:4px!important;margin-top:0;border:none;font-weight:700}.btn-all-excel,.btn-all-excel i{margin-left:5px}.btn-all-excel:hover{color:#fff;background-color:#008d45}.right{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6245d4e8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/nps/analyzeNps.vue
// module id = 754
// module chunks = 0